import "./ShowUser.css";

import { Breadcrumb, Button, message, Tag } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteUser, useAppSelector } from "../../../_lib/_store";

export const ShowUserPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.user);

  const navigate = useNavigate();
  const { state } = useLocation();

  const userObj = state?.user;

  const handleDelete = async () => {
    const res = await deleteUser(messageApi, userObj?.id);
    if (res) {
      navigate("/user");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/user">User</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/user/edit`, {
                  state: { user: state?.user },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Email</p>
            <p className="value">{userObj?.email}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{userObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Full Name</p>
            <p className="value">{userObj?.fullName}</p>
          </div>
          <div className="row">
            <p className="label">Is Registration Complete</p>
            <Tag>{userObj?.isRegistrationComplete ? "Yes" : "No"}</Tag>
          </div>
          <div className="row">
            <p className="label">Role</p>
            <Tag color="gray">{userObj?.role}</Tag>
          </div>
          <div className="row">
            <p className="label">Email Verified</p>
            <Tag>{userObj?.emailVerified ? "Yes" : "No"}</Tag>
          </div>
          <div className="row">
            <p className="label">Purchase Flag</p>
            <Tag>{userObj?.purchaseFlag ? "Yes" : "No"}</Tag>
          </div>
        </div>
      </div>
    </>
  );
};
